/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateServiceTypeComponent } from './create-service-type.component';
import { FormsModule } from '@angular/forms';
import { AngularDraggableModule } from 'angular2-draggable';
import { RouterModule, Routes } from '@angular/router';
import { AlertModule } from '../../../../../../../shared/ui/src/lib/components/alert';

const routes: Routes = [{ path: 'dialog/create-service-type-dialog', component: CreateServiceTypeComponent }];

@NgModule({
  declarations: [CreateServiceTypeComponent],
  imports: [
    CommonModule,
    FormsModule,
    AngularDraggableModule,
    AlertModule,
    RouterModule.forChild(routes)
  ],
  exports: [CreateServiceTypeComponent]
})
export class CreateServiceTypeModule { }